export var RESOLVE_METHOD;
(function (RESOLVE_METHOD) {
  RESOLVE_METHOD["COMPONENT"] = "component";
  RESOLVE_METHOD["CONSUMER"] = "consumer";
  RESOLVE_METHOD["ORPHANED"] = "orphaned";
})(RESOLVE_METHOD || (RESOLVE_METHOD = {}));